





































import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    "cprods-provider": () =>
      import("@/components/app/global/contractProducts/cProdsProvider.vue"),
    "cprod-row-with-funcs": () =>
      import("@/components/app/global/contractProducts/cProdRowWithFuncs.vue")
  }
})
export default class CProdRowsWithFuncs extends Vue {
  // Props
  @Prop({ default: 3 })
  public skeletonCount!: number;
}
